import React, { Component } from 'react';
import { connect } from 'react-redux';
import RegisterView from './RegisterView';
import { setLoginAction } from '../../store/Login/actions';
import { setTokenAction } from '../../store/Layout/actions';

class RegisterController extends Component {

    render(){

        return(
            <RegisterView
                trans={this.props.trans}
                csrf_token={this.props.csrf_token}
                config={this.props.config}
                setLoginAction={this.props.setLoginAction}
                setTokenAction={this.props.setTokenAction}
            />
        );

    }

}

const mapStateToProps = state => {

    return {
        csrf_token: state.layout.csrf_token,
        config: state.layout.config,
        trans: state.layout.trans,
        login: state.login.email
    }

};

const mapDispatchToProps = {
    setLoginAction,
    setTokenAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( RegisterController );